import PageHeader from 'src/components/page-header/PageHeader';

export default PageHeader;
